import React, { useState } from "react";
import { FiSearch } from "react-icons/fi";
import Swal from "sweetalert2";
import { popular } from "../constants/popular";

const SearchPage = () => {
  const [query, setQuery] = useState("");
  
  const handleSearch = () => {
    Swal.fire({
      icon: "info",
      title: "Coming Soon",
      text: `Searching for: ${query}`,
    });
  };

  const handleRecentClick = (title) => {
    setQuery(title);
    Swal.fire({
      icon: "info",
      title: "Coming Soon",
      text: `You clicked on: ${title}`,
    });
  };

  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <div className="max-w-3xl mx-auto mt-28 mb-8 flex flex-col items-center gap-4">
        <div className="text-2xl text-yellow-500 font-semibold">
          Search Your Food Here
        </div>

        <div className="w-full flex items-center gap-2">
          <form
            onSubmit={(e) => {
              e.preventDefault();
              handleSearch();
            }}
            className="relative flex-grow"
          >
            <input
              type="text"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder="Search your favorite dish..."
              className="w-full pl-12 pr-4 py-3 rounded-full border border-gray-300 focus:outline-none focus:ring-2 focus:ring-yellow-400"
            />
            {/* Search icon inside input */}
            <button
              type="submit"
              className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-600 p-2 rounded-full hover:bg-gray-100 transition"
            >
              <FiSearch className="text-lg" />
            </button>
          </form>

          {/* Additional search icon after the input */}
          <button
            onClick={handleSearch}
            className="p-3 rounded-full border border-gray-300 text-gray-600 hover:bg-gray-100 transition"
          >
            <FiSearch className="text-lg" />
          </button>
        </div>
      </div>

      <div className="max-w-3xl mx-auto mb-8">
        <h2 className="text-lg font-semibold text-gray-700 mb-3">
          Recent Searches
        </h2>
        <div className="flex flex-wrap gap-2">
          {popular.map((item, index) => (
            <button
              key={index}
              onClick={() => handleRecentClick(item.title)}
              className="px-4 py-2 bg-white border border-gray-300 rounded-full hover:bg-yellow-100 transition"
            >
              {item.title}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SearchPage;
